export default "__VITE_ASSET__gtJ9_5nj__"